import React, { useEffect, useState } from 'react'
import { withRouter, useParams } from 'react-router'
import { generateStoriesImage } from '../utils/certificateGenerator'
import { sendLead } from '../service'
import './AltaHospitalarPreview.css'

const AltaHospitalarPreview = ({ history }) => {
  const { day } = useParams()

  const [data, setData] = useState(null)
  const [storiesUrl, setStoriesUrl] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const loadCertificate = async () => {
      const savedData = localStorage.getItem('certificateData')

      if (!savedData) {
        history.push(`/gerar-alta-hospitalar/${day}`)
        return
      }

      const hasLead = localStorage.getItem(`lead-day-${day}`)
      if (!hasLead) {
        await sendLead(savedData, Number(day))
        localStorage.setItem(`lead-day-${day}`, true)
      }

      const certificateData = JSON.parse(savedData)
      setData(certificateData)

      try {
        const storiesImage = await generateStoriesImage(certificateData, day)
        setStoriesUrl(storiesImage)
      } catch (error) {
        console.error('Erro ao gerar certificados:', error)
      } finally {
        setLoading(false)
      }
    }

    loadCertificate()
  }, [history])

  const handleDownloadStories = async () => {
    try {
      // Converter PNG para JPEG
      const img = new Image()
      img.crossOrigin = 'anonymous'
      img.src = storiesUrl

      await new Promise((resolve) => {
        img.onload = resolve
      })

      const canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      const ctx = canvas.getContext('2d')

      // Preencher fundo branco (JPEG não suporta transparência)
      ctx.fillStyle = '#FFFFFF'
      ctx.fillRect(0, 0, canvas.width, canvas.height)

      // Desenhar a imagem
      ctx.drawImage(img, 0, 0)

      // Converter para JPEG
      const jpegUrl = canvas.toDataURL('image/jpeg', 0.95)

      const link = document.createElement('a')
      link.download = `Alta_Hospitalar_${data?.name.replace(/\s+/g, '_')}.jpeg`
      link.href = jpegUrl
      link.click()
    } catch (error) {
      console.error('Erro ao baixar imagem:', error)
    }
  }

  const handleShareWhatsApp = async () => {
    try {
      const response = await fetch(storiesUrl)
      const blob = await response.blob()
      const file = new File([blob], 'alta-hospitalar.png', { type: 'image/png' })

      if (navigator.share && navigator.canShare({ files: [file] })) {
        await navigator.share({
          files: [file],
          title: 'Alta Hospitalar - ENEM 2025',
          text: '🏥 Recebi alta do SOS Aprova! Estou APTO(A) para o ENEM 2025! 🎓'
        })
      } else {
        const text = encodeURIComponent(`🏥 Recebi alta do SOS Aprova! Estou APTO(A) para o ENEM 2025! 🎓`)
        window.open(`https://wa.me/?text=${text}`, '_blank')
      }
    } catch (error) {
      console.error('Erro ao compartilhar:', error)
      const text = encodeURIComponent(`🏥 Recebi alta do SOS Aprova! Estou APTO(A) para o ENEM 2025! 🎓`)
      window.open(`https://wa.me/?text=${text}`, '_blank')
    }
  }

  const handleShareInstagram = async () => {
    try {
      const response = await fetch(storiesUrl)
      const blob = await response.blob()
      const file = new File([blob], 'alta-hospitalar-stories.png', { type: 'image/png' })

      if (navigator.share && navigator.canShare({ files: [file] })) {
        await navigator.share({
          files: [file],
          title: 'Alta Hospitalar - ENEM 2025',
          text: '🏥 Recebi alta do SOS Aprova! Estou APTO(A) para o ENEM 2025! 🎓'
        })
      } else {
        handleDownloadStories()
      }
    } catch (error) {
      console.error('Erro ao compartilhar:', error)
      handleDownloadStories()
    }
  }

  const handleNewCertificate = () => {
    localStorage.removeItem('certificateData')
    history.push('/gerar-alta-hospitalar')
  }

  if (loading) {
    return (
      <div className="preview-page">
        <div className="loading">
          <div className="spinner"></div>
          <p>Gerando sua alta hospitalar...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="preview-page mobile-first" style={{ background: '#000C29' }}>
      <header className="preview-header-mobile">
        <img src="/images/logo-mini-color.svg" alt="Logo Aprova" className="logo-mobile" />
        <div className="header-content">
          <h1 style={{ textAlign: 'center', marginRight: '4.5rem' }}>🎉 Sua Alta do dia {day} está Pronta! </h1>
          <p style={{ textAlign: 'center', marginRight: '4.5rem' }}>Compartilhe e mostre que você está preparado!</p>
        </div>
      </header>

      <div className="main-content">
        <div className="certificate-display">
          <div className="certificate-frame">
            <img src={storiesUrl} alt="Alta Hospitalar" className="certificate-image" />
          </div>
        </div>
      </div>

      <div className="floating-footer">
        <div className="footer-content">
          <button className="btn-share-footer instagram" onClick={handleShareInstagram} title="Compartilhar no Instagram">
            <span className="icon">📸</span>
            <span className="text">Instagram</span>
          </button>

          <button className="btn-share-footer whatsapp" onClick={handleShareWhatsApp} title="Compartilhar no WhatsApp">
            <span className="icon">💬</span>
            <span className="text">WhatsApp</span>
          </button>

          <button className="btn-share-footer download" onClick={handleDownloadStories} title="Baixar imagem">
            <span className="icon">⬇️</span>
            <span className="text">Baixar</span>
          </button>

          <button className="btn-share-footer new-cert" onClick={handleNewCertificate} title="Gerar nova alta">
            <span className="icon">➕</span>
            <span className="text">Nova Alta</span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default withRouter(AltaHospitalarPreview)
